// LEGACY CODE
// TODO: Rename this function or remove it.
// This can be simply done via Rails Application Helpers.
export function jqueryCssInit() {
  $('.boolean').each(function () {
    var text = $(this).text();

    if (text === 'true') {
      $(this).html('<i class="glyphicon glyphicon-ok text-success" />');
    } else if (text === 'false') {
      $(this).html('<i class="glyphicon glyphicon-remove text-danger" />');
    }
  });
}